module.exports = __webpack_public_path__ + "static/media/rheem-logo-color.7761f3ec.svg";